import { ConvertKit } from '@tiptap-pro/extension-convert-kit';
import type { Extension } from '@tiptap/core';

import { numberingFormats } from '../numbering-formats';

// Our editors already register everything ConvertKit bundles, so only the nodes
// export would otherwise miss are enabled. `orderedListNumbering` is off by
// default even inside ConvertKit, and without it an imported list loses its
// numbering reference before export reads it.
export function createConvertKitExtension(): Extension {
  return ConvertKit.configure({
    orderedListNumbering: { formats: numberingFormats },
    bookmark: {},
    document: false,
    text: false,
    paragraph: false,
    heading: false,
    blockquote: false,
    bold: false,
    italic: false,
    underline: false,
    strike: false,
    code: false,
    link: false,
    bulletList: false,
    orderedList: false,
    listItem: false,
    listKeymap: false,
    taskList: false,
    taskItem: false,
    hardBreak: false,
    horizontalRule: false,
    dropcursor: false,
    gapcursor: false,
    codeBlock: false,
    image: false,
    textStyleKit: false,
    textAlign: false,
    highlight: false,
    superscript: false,
    subscript: false,
    pageBreak: false,
    table: false,
    undoRedo: false,
  });
}
